import { apiSimulator } from './api-simulator.service';

export interface StaffQuote {
  clubId: string;
  staffMemberId: string;
  staffType: string;
  fromRating: number;
  toRating: number;
  ruleSetVersion: string;
  quotedCost: number;
  annualSalaryReference: number;
  staffVersion: number;
}
export interface StaffRequest {
  operationId: string;
  ruleSetVersion: string;
  expectedStaffVersion: number;
  quotedCost: number;
  annualSalaryReference: number;
}
export interface StaffOperation extends StaffQuote {
  id: string;
  status: 'REQUESTED' | 'FUNDS_CONFIRMED' | 'CAPTURE_PENDING' | 'FUNDS_CAPTURED' |
    'REVERSAL_PENDING' | 'CANCEL_REQUESTED' | 'APPLIED' | 'FAILED' | 'CANCELLED';
}
export interface StaffTraining {
  seasonId: string;
  matchdayId: string;
  completionMatchdayNumber: number;
  durationMatchdays: number;
  remainingMatchdays: number;
}
export interface StaffClubStatus {
  clubId: string;
  activeUpgrades: { operation: StaffOperation; training: StaffTraining | null }[];
  slot: {
    availability: 'AVAILABLE' | 'LIMIT_REACHED' | 'NO_CALENDAR' | 'CALENDAR_UNAVAILABLE';
    completionMatchdayNumber: number | null;
    consumedByOperationId: string | null;
  };
}
const base = (clubId: string) => `/api/clubs/${encodeURIComponent(clubId)}/staff`;
const member = (clubId: string, staffId: string) => `${base(clubId)}/${encodeURIComponent(staffId)}/upgrades`;
const call = <T>(method: 'GET' | 'POST', endpoint: string, body?: StaffRequest) =>
  apiSimulator.callWithMockFallback<T>({ method, endpoint, body, service: 'clubs', mockName: '', allowMockFallback: false });

export const staffUpgradesApi = {
  status: (clubId: string) => call<StaffClubStatus>('GET', `${base(clubId)}/upgrades/status`),
  quote: (clubId: string, staffId: string) => call<StaffQuote>('GET', `${member(clubId, staffId)}/quote`),
  request: (clubId: string, staffId: string, body: StaffRequest) => call<StaffOperation>('POST', member(clubId, staffId), body),
  operation: (clubId: string, staffId: string, id: string) => call<StaffOperation>('GET', `${member(clubId, staffId)}/${encodeURIComponent(id)}`),
};

export function staffRequest(quote: StaffQuote, operationId: string): StaffRequest {
  return { operationId, ruleSetVersion: quote.ruleSetVersion, expectedStaffVersion: quote.staffVersion,
    quotedCost: quote.quotedCost, annualSalaryReference: quote.annualSalaryReference };
}
